import React from 'react';

import { Box } from '../Box';
import { type IconSize, type IconVariantTypes, Icon } from '../Icon';
import { type TTextSize, Text } from '../Typography';

export type IconLabelProps = {
  /**
   * Icon variant to display
   */
  variant: IconVariantTypes;
  /**
   * Text label or React node to display next to the icon
   */
  label: React.ReactNode;
  /**
   * Size of the label text
   */
  labelSize?: TTextSize;
  /**
   * Size of the icon
   */
  iconSize?: IconSize;
  /**
   * Additional CSS class names
   */
  className?: string;
};

const IconLabel = ({
  variant,
  label,
  iconSize = 'large',
  labelSize = 'sm',
  className,
  ...rest
}: IconLabelProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="var(--spacing-1)"
      className={className}
      {...rest}
    >
      <Icon variant={variant} size={iconSize} />

      <Text size={labelSize} fontWeight="semibold">
        {label}
      </Text>
    </Box>
  );
};

export default IconLabel;
